<template>
    <div class="container-fluid" >
        <div class="justify-content-between">
            <div>
                <h3>Багш</h3>
            </div>
            <div >
                <p>
                    "Багшийн код Имэйл" форматаар оруулна уу!!!.  Жишээ нь:
                    <br/>
                    D123456 bagsh@email.com<br/>
                    D123457 bagsh@email.com
                </p>
                <div class="form-group">
                    <textarea rows="10" v-model.trim="teachersText" class="form-control" placeholder="Багш нарын мэдээлэл"/>
                </div>
            
                <button type="button" class="btn btn-primary" @click="addTeachers">
                    Багш нэмэх
                </button>
                <hr>
              
            </div>
        
        </div>
        <div class="card shadow my-4">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Багш нарын жагсаалт</h6>
            </div>
            <div class="card-body">
                <div class="table-responsive" v-if="teachers!=null && teachers.length>0">
                <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                    <thead>
                    <tr>
                        <th>№</th>
                        <th>Нэр</th>
                        <th>Овог</th>
                        <th>Багшийн код</th>
                        <th>Имэйл</th>
                        <th>Хөтөлбөр</th>
                        <th>Утас</th>
                        <th>Үйлдэл</th>
                    </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(teacher, index) in teachers" >
                            <td>{{index+1}}</td>
                            <td>{{teacher.name}}</td>
                            <td>{{teacher.lastname}}</td>
                            <td>{{teacher.code}}</td>
                            <td>{{teacher.email}}</td>
                            <td>
                                <div >
                                    <span v-if="teacher.school!=null">{{teacher.school.id}}</span>
                                    <span v-else>Сургууль сонгоогүй байна.</span>
                                </div>
                                <div >
                                    <span v-if="teacher.department!=null">{{teacher.department.id}}</span>
                                    <span v-else>Тэнхим сонгоогүй байна.</span>
                                </div>
                                <div >
                                    <span v-if="teacher.program!=null">{{teacher.program.id}}</span>
                                    <span v-else>Хөтөлбөр сонгоогүй байна.</span>
                                </div>
                            </td>
                            <td>{{teacher.phone}}</td>
                            <td>
                                <!-- <button class="btn btn-danger" @click="deleteTeacher(teacher, index)">устгах</button> -->
                                <button class="btn btn-warning" @click="_edit(teacher)">засах</button>
                            </td>
                        </tr>
                    
                    </tbody>
                </table>
                </div>
                <div v-else class="alert alert-info text-center">Одоогоор багшийн мэдээлэл ороогүй байна.</div>
            </div>
        </div>

    </div>
    
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../../firebaseConfig.js')

    export default {
        data() {
            return {
               teachers:[],
               teachersText:null,
               tmpTeachers:[]

            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        methods: {
            _getData(){
                

                fb.db.collection("teachers").orderBy('createdAt', 'desc').limit(100).get().then(querySnapshot=> {
                    this.teachers=[];
                    querySnapshot.forEach(doc=> {
                        let object=doc.data()
                        object.id = doc.id
                        this.teachers.push(object);
                    });
                });
            },
            _edit(teacher){
                this.$router.push({ name: 'TeacherAdd', params: { teacherId: teacher.id} })
            },
            addTeachers(){
                if(this.teachersText!=null && this.teachersText!=''){
                    //TODO
                    var arrayOfLines = this.teachersText.match(/[^\r\n]+/g);
                    arrayOfLines.forEach(value=>{
                        var lineArray=value.split(/\s+/);

                        console.log(1);
                        if(lineArray!=null && lineArray.length==2 && lineArray[0]!=null && lineArray[0]!='' && lineArray[1]!=null && lineArray[1]!=''){

                            var teacherRef=fb.db.collection("teachers").doc().get().then(teacherData=>{

                                if(teacherData!=null && teacherData.exists){

                                }
                                else{

                                    var teacherDetail={
                                        // 'name':lineArray[1],
                                        // 'lastname': lineArray[0],
                                        'code':lineArray[0].toLowerCase(),
                                        'email': lineArray[1].toLowerCase(),
                                        'created': fb.usersCollection.doc(this.$store.getters.currentUser.uid),
                                        'createdAt': new Date()
                                    };
                                    teacherData.ref.set(
                                        teacherDetail
                                    );

                                }
                                
                            });

                        }
                    });
                    this.teachersText=''
                    }
            },
            deleteTeacher(teacher, index){
                if(teacher!=null && teacher.id!=null){
                    fb.db.collection("teachers").doc(teacher.id).delete();
                    this.teachers.splice(index, 1);
                }
            }

        },
        created() {
            this._getData();
                
        },

        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).format('MM/DD/YYYY HH:mm');
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>
